export default {
    namespaced: true,

    state: {
        animationDirection: 'next',
        stepsTaken: [],
        finished: false,
    },

    getters: {
        isFinished(state) {
            return state.finished;
        },
        getCurrentQuestionId(state) {
            if (!state.stepsTaken.length) return null;

            return state.stepsTaken[state.stepsTaken.length -1].questionId;
        },
        currentQuestion(state, getters, rootState, rootGetters) {
            return rootGetters['questions/getQuestionById'](
                getters.getCurrentQuestionId,
            );
        },
        animationDirection(state) {
            return state.animationDirection;
        },
        canGoOneStepBack(state) {
            return state.stepsTaken.length >= 2 || state.finished === true;
        },
    },

    actions: {
        nextStep({ commit, rootGetters, state, dispatch }, answerId) {
            const lastStepIndex = state.stepsTaken.length - 1;
            const questionId = state.stepsTaken[lastStepIndex].questionId;
            const answer = rootGetters['questions/getAnswer']({ questionId, answerId });
            const targetQuestionId = answer.target_question_id;
            const showProducts = !!answer.show_products;

            commit('setAnimationDirection', 'next');
            commit('setAnswer', { index: lastStepIndex, value: answerId });

            if (showProducts) {
                commit('setAnimationDirection', 'next');
                commit('setFinished', true);
                dispatch('products/fetch', state.stepsTaken, { root: true });
            } else if (targetQuestionId) {
                dispatch('addQuestionToSteps', targetQuestionId);
            }
        },
        addQuestionToSteps({ commit, dispatch }, questionId) {
            commit('addQuestionToSteps', questionId);
            dispatch('questions/fetchForQuestion', questionId, { root: true });
        },
        goBackToStep({ state, commit, dispatch }, index) {
            if (state.finished) {
                dispatch('products/clear', null, { root: true });
                commit('setFinished', false);
            }
            commit('setAnimationDirection', 'previous');
            commit('setStepStepsTaken', index);
            commit('setAnswer', { index: index, value: null });
        },
        goBackOneStep({ state, getters, dispatch }) {
            if (!getters['canGoOneStepBack']) {
                return;
            }

            if (state.finished) {
                dispatch('goBackToStep', state.stepsTaken.length - 1);
            } else {
                dispatch('goBackToStep', state.stepsTaken.length - 2);
            }
        },
    },

    mutations: {
        setAnimationDirection(state, direction) {
            state.animationDirection = direction;
        },
        addQuestionToSteps(state, questionId) {
            state.stepsTaken.push({
                questionId: questionId,
                answerId: null,
            });
        },
        setAnswer(state, { index, value }) {
            state.stepsTaken[index].answerId = value;
        },
        setStepStepsTaken(state, index) {
            state.stepsTaken = state.stepsTaken.splice(0, index + 1);
        },
        setFinished(state, finished) {
            state.finished = finished;
        },
    },
};
